<div class="frame-in">
  <div class="items south-america-2-frame">
    <svg class="road south-america-2">
      <style type="text/css">
        tspan {
        white-space: pre
      }

      .shp0 {
      fill: none;
      stroke: #ffffff;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-width: 5;
      stroke-dasharray: 15,15
    }
  </style>
  <defs>
    <filter filterUnits="userSpaceOnUse" id="Filter_0" x="337.5px" y="385.5px" width="27px" height="94px">
      <feOffset in="SourceAlpha" dx="0" dy="4" />
      <feGaussianBlur result="blurOut" stdDeviation="0" />
      <feFlood flood-color="rgb(12, 50, 101)" result="floodOut" />
      <feComposite operator="atop" in="floodOut" in2="blurOut" />
      <feComponentTransfer><feFuncA type="linear" slope="0.65" /></feComponentTransfer>
      <feMerge>
        <feMergeNode />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
    <filter filterUnits="userSpaceOnUse" id="Filter_1" x="-2.5px" y="154.5px" width="356px" height="225px">
      <feOffset in="SourceAlpha" dx="0" dy="4" />
      <feGaussianBlur result="blurOut" stdDeviation="0" />
      <feFlood flood-color="rgb(12, 50, 101)" result="floodOut" />
      <feComposite operator="atop" in="floodOut" in2="blurOut" />
      <feComponentTransfer><feFuncA type="linear" slope="0.65" /></feComponentTransfer>
      <feMerge>
        <feMergeNode />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
    <filter filterUnits="userSpaceOnUse" id="Filter_2" x="7.5px" y="112.5px" width="563px" height="201px">
      <feOffset in="SourceAlpha" dx="0" dy="4" />
      <feGaussianBlur result="blurOut" stdDeviation="0" />
      <feFlood flood-color="rgb(12, 50, 101)" result="floodOut" />
      <feComposite operator="atop" in="floodOut" in2="blurOut" />
      <feComponentTransfer><feFuncA type="linear" slope="0.65" /></feComponentTransfer>
      <feMerge>
        <feMergeNode />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
    <filter filterUnits="userSpaceOnUse" id="Filter_3" x="498.5px" y="120.5px" width="165px" height="176px">
      <feOffset in="SourceAlpha" dx="0" dy="4" />
      <feGaussianBlur result="blurOut" stdDeviation="0" />
      <feFlood flood-color="rgb(12, 50, 101)" result="floodOut" />
      <feComposite operator="atop" in="floodOut" in2="blurOut" />
      <feComponentTransfer><feFuncA type="linear" slope="0.65" /></feComponentTransfer>
      <feMerge>
        <feMergeNode />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
    <filter filterUnits="userSpaceOnUse" id="Filter_4" x="432.5px" y="-2.5px" width="89px" height="126px">
      <feOffset in="SourceAlpha" dx="0" dy="4" />
      <feGaussianBlur result="blurOut" stdDeviation="0" />
      <feFlood flood-color="rgb(12, 50, 101)" result="floodOut" />
      <feComposite operator="atop" in="floodOut" in2="blurOut" />
      <feComponentTransfer><feFuncA type="linear" slope="0.65" /></feComponentTransfer>
      <feMerge>
        <feMergeNode />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
    <linearGradient id="PSgrad_0" x1="0%" x2="0%" y1="100%" y2="0%">
      <stop offset="0%" stop-color="rgb(255,218,83)" stop-opacity="1" />
      <stop offset="48%" stop-color="rgb(248,122,42)" stop-opacity="1" />
      <stop offset="100%" stop-color="rgb(240,25,1)" stop-opacity="1" />
    </linearGradient>
  </defs>
  <g filter="url(#Filter_0)">
    <path fill-rule="evenodd" stroke="rgb(255, 255, 255)" stroke-width="5px" stroke-dasharray="15, 15" stroke-linecap="round" stroke-linejoin="round" fill="none"
      d="M350.499,466.499 C361.420,444.794 343.499,394.499 343.499,394.499 " />
    </g>
    <g filter="url(#Filter_1)">
      <path fill-rule="evenodd" stroke="rgb(255, 255, 255)" stroke-width="5px" stroke-dasharray="15, 15" stroke-linecap="round" stroke-linejoin="round" fill="none"
        d="M343.499,367.499 C343.221,341.101 318.23,324.855 293.499,319.499 C260.416,312.274 181.885,327.3 171.499,335.499 C171.499,335.499 125.755,357.133 82.499,331.499 C39.243,305.866 -18.314,259.202 11.500,161.499 " />
      </g>
      <g filter="url(#Filter_2)">
        <path fill-rule="evenodd" stroke="rgb(255, 255, 255)" stroke-width="5px" stroke-dasharray="15, 15" stroke-linecap="round" stroke-linejoin="round" fill="none"
          d="M12.499,175.499 C19.14,122.574 82.264,117.290 118.499,117.499 C222.544,118.101 205.742,162.439 232.499,200.499 C256.8,233.938 301.34,252.481 343.499,266.499 C377.517,277.729 430.524,297.757 478.499,298.499 C519.532,299.134 562.499,293.499 562.499,293.499 " />
        </g>
        <g filter="url(#Filter_3)">
          <path fill-rule="evenodd" stroke="rgb(255, 255, 255)" stroke-width="5px" stroke-dasharray="15, 15" stroke-linecap="round" stroke-linejoin="round" fill="none"
            d="M508.499,127.499 C526.615,153.690 559.292,150.419 586.499,158.499 C586.499,158.499 653.727,165.533 657.499,215.499 C661.272,265.466 624.169,279.804 587.499,291.499 " />
          </g>
          <g filter="url(#Filter_4)">
            <path fill-rule="evenodd" fill="none"
              d="M443.499,5.499 C443.499,5.499 437.400,56.924 489.499,98.499 C489.499,98.499 498.515,104.204 516.69,109.808 " />
            </g>
            <path stroke="rgb(255, 255, 255)" stroke-width="5px" stroke-dasharray="15, 15" stroke-linecap="round" stroke-linejoin="round" fill="url(#PSgrad_0)"
              d="M443.499,5.499 C443.499,5.499 437.400,56.924 489.499,98.499 C489.499,98.499 498.515,104.204 516.69,109.808 " />
            </svg>
            <div class="country south-america-2"></div>
            <div class="poi quiz quiz-1" (click)="goQuiz()" [ngClass]="{'lock': quizLevel < 12, 'active': quizLevel === 12 && tick2Quiz}"></div>

            @for (zone of zones; track zone) {
              <div>
                <div class="country {{zone.class}}" [ngClass]="{'hover': zone.hover}"></div>
              </div>
            }

            @for (zone of zones; track zone; let i = $index) {
              <div
                class="poi {{zone.class}}"
                [ngClass]="{active: zone.active, 'lock': zone.locked}"
                (mouseenter)="mouseEnter(zone)"
                (mouseleave)="mouseLeave(zone)"
                (click)="selectZone(zone)">
                <span>{{ zone.locked ? '' : zone.number}}</span>
              </div>
            }
          </div>
        </div>

        <img class="frame-title" src="assets/images/zones/south-america-2/title.png">

        <audio id="introductionAudio" (ended)="playBgAudio()">
          <source src="assets/sounds/country.wav" type="audio/wav">
        </audio>
        <audio id="bgAudio" (ended)="playIntroductionAudio()">
          <source src="assets/sounds/zone-b-g-sound.mp3" type="audio/mpeg">
        </audio>

        <div class="footer">
          <ul class="zone-menu">
            <li>
              @if (!haveAccess('4-1')) {
                <span class="lock"></span>
              }
              @if (haveAccess('4-1')) {
                <a class="menu-item" [routerLink]="[ '/game/south-america-1' ]" routerLinkActive="active">1</a>
              }
            </li>
            <li>
              @if (!haveAccess('4-2')) {
                <span class="lock"></span>
              }
              @if (haveAccess('4-2')) {
                <a class="menu-item" [routerLink]="[ '/game/south-america-2' ]" routerLinkActive="active">2</a>
              }
            </li>
            <li>
              @if (!haveAccess('4-3')) {
                <span class="lock"></span>
              }
              @if (haveAccess('4-3')) {
                <a class="menu-item" [routerLink]="[ '/game/south-america-3' ]" routerLinkActive="active">3</a>
              }
            </li>
          </ul>
          <img class="footer-bg" src="assets/images/zones/south-america-2/footer.png">
        </div>

        <audio id="continentHover">
          <source src="assets/sounds/continent_hover.mp3" type="audio/mpeg">
        </audio>
        <audio id="continentClick">
          <source src="assets/sounds/continent_selection.mp3" type="audio/mpeg">
        </audio>
